import React from 'react';
import { Routes, Route } from "react-router-dom";

import AdminRoute from './Components/Routes/AdminRoute';
import AdminLayout from './Components/Layouts/AdminLayout';
import HomeScreen from './Screens/HomeScreen';
import AdmissionScreen from './Screens/AdmissionScreen';
import FacultyScreen from './Screens/FacultyScreen';
import AboutScreen from './Screens/AboutScreen';
import CareerScreen from './Screens/CareerScreen';
import GalleryScreen from './Screens/GalleryScreen';
import NewsScreen from './Screens/NewsScreen';
import LoginScreen from "./Screens/LoginScreen";
import OasisCrecheScreen from "./Screens/OasisCrecheScreen";
import ModelPapersScreen from "./Screens/ModelPapersScreen";
import PageNotFound from './Screens/PageNotFound';
import AssignmentScreen from './Screens/AssignmentsScreen';
import SyllabusScreen from './Screens/SyllabusScreen';
import ChairmansMessage from './Screens/ChairmansMessage';
import NewsArticle from './Screens/NewsArticle';
import ManagementScreen from './Screens/ManagementScreen';
import RegisterScreen from './Screens/AdminScreens/RegisterScreen';
import AdminDashboard from './Screens/AdminScreens/AdminDashboard';
import ManageNotifications from './Screens/AdminScreens/ManageNotifications';
import ManageAssignments from './Screens/AdminScreens/ManageAssignments';
import ManageCareers from './Screens/AdminScreens/ManageCareers';
import ManageSyllabus from './Screens/AdminScreens/ManageSyllabus';
import ManageGallery from './Screens/AdminScreens/ManageGallery';
import ManageResults from './Screens/AdminScreens/ManageResults';
import ManageNews from './Screens/AdminScreens/ManageNews';
import ManageAdmission from './Screens/AdminScreens/ManageAdmission';
import ManageModelPapers from './Screens/AdminScreens/ManageModelPapers';
import ManageFaculty from './Screens/AdminScreens/ManageFaculty';
import ManageExecutives from './Screens/AdminScreens/ManageExecutives';
import ManageEvents from './Screens/AdminScreens/ManageEvents'


;


const AppRoutes = () => {
    return (

        <Routes >
            <Route path="/" element={<HomeScreen />} />
            <Route path="/admission" element={<AdmissionScreen />} />
            <Route path="/about" element={<AboutScreen />} />
            <Route path="/management" element={<ManagementScreen />} />
            <Route path="/faculty" element={<FacultyScreen/>} />
            <Route path="/careers" element={<CareerScreen />} />
            <Route path="/gallery" element={<GalleryScreen />} />
            <Route path="/news" element={<NewsScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/syllabus" element={<SyllabusScreen />} />
            <Route path="/assignments" element={<AssignmentScreen />} />
            <Route path="/oasis-creche" element={<OasisCrecheScreen />} />
            <Route path="/model-papers" element={<ModelPapersScreen />} />
            <Route path='/chairmans-message' element={<ChairmansMessage />} />
            <Route path='/news/:id' element={<NewsArticle />} />

            <Route path="/register" element={
                <AdminRoute>
                    <RegisterScreen />
                </AdminRoute>} />

            <Route path="admin" element={
                <AdminRoute>
                    <AdminLayout />
                </AdminRoute>
            } >
                <Route index element={
                    <AdminRoute>
                        <AdminDashboard />
                    </AdminRoute>
                } ></Route>
                <Route path="notifications" element={
                    <AdminRoute>
                        <ManageNotifications />
                    </AdminRoute>} />
                <Route path="careers" element={
                    <AdminRoute>
                        <ManageCareers />
                    </AdminRoute>} />
                <Route path="results" element={
                    <AdminRoute>
                        <ManageResults />
                    </AdminRoute>} />
                <Route path="assignments" element={
                    <AdminRoute>
                        <ManageAssignments />
                    </AdminRoute>} />
                <Route path="syllabus" element={
                    <AdminRoute>
                        <ManageSyllabus />
                    </AdminRoute>} />
                <Route path="gallery" element={
                    <AdminRoute>
                        <ManageGallery />
                    </AdminRoute>} />
                <Route path="news-events" element={
                    <AdminRoute>
                        <ManageNews />
                    </AdminRoute>} />
                <Route path="admission" element={
                    <AdminRoute>
                        <ManageAdmission />
                    </AdminRoute>} />
                <Route path="model-papers" element={
                    <AdminRoute>
                        <ManageModelPapers />
                    </AdminRoute>} />
                <Route path="faculty" element={
                    <AdminRoute>
                        <ManageFaculty />
                    </AdminRoute>} />
                    <Route path="management" element={
                    <AdminRoute>
                        <ManageExecutives/>
                    </AdminRoute>} />
                    <Route path="upcoming-events" element={
                    <AdminRoute>
                        <ManageEvents/>
                    </AdminRoute>} />
            </Route >

            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};

export default AppRoutes;
